import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  gap: 16px;
  background: ${myPalette.midnightBlue.lightBlue};
  border-radius: 8px;
`
